import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useState } from 'react';
export const MultiStepFormContext = createContext({});
export const useMultiStepForm = () => useContext(MultiStepFormContext);
export function MultiStepFormProvider({ steps, children }) {
    const [currentStep, setCurrentStep] = useState(0);
    const context = {
        steps,
        isLastStep: currentStep === steps.length - 1,
        isFirstStep: currentStep === 0,
        goToStep: (step) => setCurrentStep(step),
        nextStep: () => setCurrentStep((prev) => prev + 1),
        previousStep: () => setCurrentStep((prev) => prev - 1),
        getCurrentStep: () => ({ index: currentStep, ...steps[currentStep] }),
    };
    return (_jsx(MultiStepFormContext.Provider, { value: context, children: typeof children === 'function' ? children(context) : children }));
}
